<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('shortDomains.shortDomainsList') }}

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >

                    <router-link
                        v-if="isLoaded"
                        :to="{
                            name: 'short-domains.new',
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('addNew') }}</span>
                        <span class="hidden-xs">{{ $t('addNew') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-edit"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <div
                            v-show="isLoaded"
                            class="box-header with-border"
                        >
                            <h3 class="box-title">Short Domains Table</h3>

                            <div class="box-tools pull-right">
                                <button
                                    class="btn btn-box-tool"
                                    :title="$t('collapse')"
                                    type="button"
                                    @click="isCollapse = !isCollapse"
                                >
                                    <i
                                        class="fa"
                                        :class="{
                                            'fa-plus': !isCollapse,
                                            'fa-minus': isCollapse,
                                        }"
                                    />
                                </button>
                            </div>
                        </div>

                        <vue-slide-up-down
                            v-show="isLoaded"
                            :active="isCollapse"
                        >
                            <ShortDomainsTable
                                :route="route"
                                :type="type"
                                :display-account="true"
                                v-bind="$attrs"
                                @loaded="isLoaded = $event"
                            />
                        </vue-slide-up-down>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ShortDomainsTable from '@/components/short-domains/ShortDomainsTable';

export default {
    components: {
        ShortDomainsTable,
    },

    data() {
        return {
            isCollapse: true,
            isLoaded: false,
            route: {
                show: this.$route.path + '/:id:',
                edit: this.$route.path + '/:id:/edit',
                feedbackShow: '/feedback/:id:',
                campaignsShow: '/campaigns/:id:',
                sdAccountsShow: '/sd-accounts/:id:',
            },
            type: {
                campaign: 'SMSPlatform\\Models\\Campaign\\Campaign',
                feedback: 'SMSPlatform\\Models\\Feedback\\Feedback',
            },
        };
    },
};
</script>
